module.exports = __webpack_public_path__ + "static/media/font_medium.0c12749c.woff";